import { motion } from "framer-motion";

export default function Lightbox({ items, currentIndex, onClose, onNavigate }) {
  const item = items[currentIndex];
  if (!item) return null;

  const prev = () => onNavigate((currentIndex - 1 + items.length) % items.length);
  const next = () => onNavigate((currentIndex + 1) % items.length);

  return (
    <motion.div
      className="lightbox-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") onClose();
        if (e.key === "ArrowLeft") prev();
        if (e.key === "ArrowRight") next();
      }}
      tabIndex={-1}
      role="dialog"
      aria-label="Image lightbox"
    >
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>Close ✕</button>

        <motion.img
          key={currentIndex}
          src={item.src}
          alt={item.label}
          className="lightbox-image"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        />

        <div className="lightbox-info">
          <span className="lightbox-ref">{item.ref} — {item.label}</span>
          <div className="lightbox-controls">
            <button className="lightbox-btn" onClick={prev}>← Prev</button>
            <span style={{ color: "var(--muted)", fontSize: "0.7rem", fontFamily: "var(--font-body)" }}>
              {currentIndex + 1} / {items.length}
            </span>
            <button className="lightbox-btn" onClick={next}>Next →</button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
